import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import {
  CreateOrUpdateUserValueOfPurchasePointStrategiesCommand,
  GetAllPossiblePointPerIndexDto,
  GetEnumValuesDto,
  GetUserValueOfPurchasesListDto,
} from 'src/app/core/api/models';
import {
  UserValueOfPurchasePointStrategiesService,
  UserValueOfPurchaseStrategiesService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';

import { isEqual as _isEqual, cloneDeep } from 'lodash';
import { DialogService } from 'src/app/core/services/dialog.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';

@Component({
  selector: 'app-value-of-purchase-point-strategies-form',
  templateUrl: './value-of-purchase-point-strategies-form.component.html',
  styleUrls: ['./value-of-purchase-point-strategies-form.component.scss'],
  imports: [BaseFormModule],
})
export class ValueOfPurchasePointStrategiesFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  pageVocabs = 'pages.groupPrice.detailForm.';

  @Input() formPageConfig: FormPageConfig<any[]>;
  @Input() pointPerIndexModel: Array<GetAllPossiblePointPerIndexDto> = [];
  @Input() allPossibleIndices: GetEnumValuesDto[] = [];
  basePointPerIndexModel: Array<GetAllPossiblePointPerIndexDto> = [];
  userValueOfPurchasesList: Array<GetUserValueOfPurchasesListDto> | null;

  model: CreateOrUpdateUserValueOfPurchasePointStrategiesCommand = {};
  selectedRequests: any[] = [];
  strategy: any;
  selectedRows = new Set<number>();
  lastSelectedIndex: number | null = null;
  innerWidth: number;
  //#endregion

  constructor(
    protected currentService: UserValueOfPurchasePointStrategiesService,
    protected userValueOfPurchaseStrategies: UserValueOfPurchaseStrategiesService,
    protected utilityService: UtilityService,
    protected dialogService: DialogService,
    protected renderer: Renderer2
  ) {
    super();
  }

  ngOnInit() {
    this.loading = false;
    this.title = this.pageVocabs + 'legend';
    this.getItemsApi();
    this.basePointPerIndexModel = cloneDeep(this.pointPerIndexModel);
  }

  ngAfterViewChecked(): void {
    this.innerWidth = window.innerWidth;
  }

  //#region init methods

  initForm() {}

  //#endregion

  //#region Api
  //create or update
  createOrUpdateApi(
    model: CreateOrUpdateUserValueOfPurchasePointStrategiesCommand
  ) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .userValueOfPurchasePointStrategiesCreateOrUpdate({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  //#region operation

  onReset() {
    this.loading = true;
    super.onReset();
    this.pointPerIndexModel = cloneDeep(this.basePointPerIndexModel);

    this.loading = false;
  }

  onSubmit() {
    if (this.loading) return;
    this.model.requests = Object.assign([], this.pointPerIndexModel);
    try {
      this.createOrUpdateApi(this.model);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#endregion

  getItemsApi() {
    this.userValueOfPurchaseStrategies
      .userValueOfPurchaseStrategiesGetUserValueOfPurchaseStrategiesList()
      .pipe(this.basePipeOperators())
      .subscribe((result) => {
        if (result.isSucceed) this.userValueOfPurchasesList = result.data;
      });
  }

  //this is not used
  removeStrategyValue(pointPerIndices: GetAllPossiblePointPerIndexDto) {
    pointPerIndices.userValueOfPurchaseStrategyTitle = null;
  }

  changeStrategy(event) {
    this.pointPerIndexModel.forEach((pointPerIndex) => {
      const exists = this.selectedRequests.some((array) =>
        _isEqual(array, pointPerIndex.pointPerIndices)
      );

      if (exists) pointPerIndex.userValueOfPurchaseStrategyTitle = event.title;
    });
  }

  selectRow(index: number, event: any) {
    if (
      !(event?.target?.className as string)?.includes('selectable-cell') &&
      innerWidth > 768
    )
      return;

    //when use shift
    if (event.shiftKey && this.lastSelectedIndex !== null) {
      this.selectedRows.clear();
      this.selectedRequests = [];
      // Select range of rows
      const start = Math.min(this.lastSelectedIndex, index);
      const end = Math.max(this.lastSelectedIndex, index);
      let firstValue =
        this.pointPerIndexModel[start].userValueOfPurchaseStrategyTitle;
      let isAllSameTitle = true;
      for (let i = start; i <= end; i++) {
        this.selectedRows.add(i);
        this.selectedRequests.push(this.pointPerIndexModel[i].pointPerIndices);
        if (
          this.pointPerIndexModel[i].userValueOfPurchaseStrategyTitle !==
          firstValue
        ) {
          isAllSameTitle = false;
        }
      }
    } else if (event.ctrlKey || innerWidth < 768) {
      //when use Ctrl
      this.setModel(index);
    } else {
      //when use only click
      this.selectedRows.clear();
      this.selectedRequests = [];
      this.setModel(index);
    }
  }

  setStrategyValue(isAllSameTitle, title) {
    if (isAllSameTitle) this.strategy = title;
    else this.strategy = null;
  }

  setModel(index) {
    // Toggle selection
    if (this.selectedRows.has(index)) {
      this.selectedRows.delete(index);
      // Filter out the array that matches arrayToRemove
      this.selectedRequests = this.selectedRequests.filter(
        (subArray) =>
          JSON.stringify(subArray) !==
          JSON.stringify(this.pointPerIndexModel[index].pointPerIndices)
      );
    } else {
      this.selectedRows.add(index);
      this.selectedRequests.push(
        this.pointPerIndexModel[index].pointPerIndices
      );
    }
    this.lastSelectedIndex = index; // Store last selected row
  }
  
}
